import { render, staticRenderFns } from "./customerTickets.vue?vue&type=template&id=3d4047ba&scoped=true"
import script from "./customerTickets.vue?vue&type=script&lang=js"
export * from "./customerTickets.vue?vue&type=script&lang=js"
import style0 from "./customerTickets.vue?vue&type=style&index=0&id=3d4047ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4047ba",
  null
  
)

export default component.exports